<template>
	<div class="Header-group" :class="{ 'Header-group--secondary': secondary }">
		<!-- @slot for the header group-->
		<slot />
	</div>
</template>

<script>
export default {
	name: 'CloHeaderGroup',
	data() {
		return {};
	},
	props: {
		secondary: Boolean,
	},
	computed: {},
};
</script>
